module.exports = __webpack_public_path__ + "img/local-1.4e8fbd53.jpg";